var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-feature-products-screen"},[_c(_vm.type,_vm._b({tag:"component"},'component',_vm.componentProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }